
 export const themeCustomizer= [
        {
            "id":"check-layout",
            "class":"check-layout",
            "title":"Check Layout",
            "icon":"icofont-laptop-alt",
            "settings":""
        },
        {
            "id":"sidebar-type",
            "class":"sidebar-type",
            "title":"Sidebar Type",
            "icon":"icofont-ui-settings",
            "settings":""
        },
        {
            "id":"color-picker",
            "class":"color-picker",
            "title":"Color Picker",
            "icon":"icofont-color-bucket",
            "settings":"color-settings"
        }
    ]

    export const checkLayout =[
        {
            "src":"1.jpg",
            "title":"Default layout",
            "class":"default-sidebar"
        },
        {
            "src":"2.jpg",
            "title":"Compact layout",
            "class":"compact-sidebar"
        },
        {
            "src":"3.jpg",
            "title":"Modern layout",
            "class":"modern-sidebar"
        }
    ]